export default function ConsultancyServices() {
  const services = [
    {
      title: 'BSF Farm Setup Consultancy',
      description: 'Complete guidance for establishing your BSF farming operation from site selection to production start.',
      icon: 'ri-building-line',
      features: [
        'Site Assessment & Planning',
        'Infrastructure Design',
        'Equipment Procurement',
        'Setup Supervision',
        'Staff Training',
        'Production Launch'
      ],
      duration: '2-4 weeks',
      price: 'Project Based'
    },
    {
      title: 'Production Optimization',
      description: 'Improve your existing BSF farm efficiency, yield, and profitability through expert analysis.',
      icon: 'ri-line-chart-line',
      features: [
        'Production Analysis',
        'Process Optimization',
        'Quality Improvement',
        'Cost Reduction Strategies',
        'Yield Enhancement',
        'Performance Monitoring'
      ],
      duration: '1-2 weeks',
      price: 'Project Based'
    },
    {
      title: 'Market Linkage & Export Support',
      description: 'Connect with buyers and navigate export requirements for BSF products and by-products.',
      icon: 'ri-global-line',
      features: [
        'Market Research',
        'Buyer Connections',
        'Export Documentation',
        'Quality Certification',
        'Logistics Support',
        'Contract Negotiation'
      ],
      duration: 'Ongoing',
      price: 'Commission Based'
    },
    {
      title: 'Research & Development',
      description: 'Collaborative research projects and product development for innovative BSF applications.',
      icon: 'ri-microscope-line',
      features: [
        'Product Development',
        'Research Collaboration',
        'Innovation Projects',
        'Technical Documentation',
        'Patent Support',
        'Publication Assistance'
      ],
      duration: '3-12 months',
      price: 'Project Based'
    }
  ];

  const scrollToInquiryForm = () => {
    const inquirySection = document.getElementById('product-inquiry');
    if (inquirySection) {
      inquirySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Consultancy Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Expert consultancy services to help you establish, optimize, and scale your BSF farming operations successfully.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className={`${service.icon} text-2xl text-green-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">
                    {service.title}
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span>{service.duration}</span>
                    <span>•</span>
                    <span className="font-semibold text-green-600">{service.price}</span>
                  </div>
                </div>
              </div>

              <p className="text-gray-600 mb-6">
                {service.description}
              </p>

              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-3">Service Includes:</h4>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-green-600 mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex gap-3">
                <button 
                  onClick={scrollToInquiryForm}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
                  Get Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Why Choose Our Consultancy?
              </h3>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-star-fill text-yellow-500 mr-3 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Proven Expertise:</strong>
                    <span className="text-gray-600"> Over 5 years of BSF farming experience</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-team-fill text-blue-500 mr-3 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Local Knowledge:</strong>
                    <span className="text-gray-600"> Deep understanding of Ghanaian agricultural context</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-global-fill text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">International Standards:</strong>
                    <span className="text-gray-600"> Export-quality production guidance</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-support-fill text-purple-500 mr-3 mt-1"></i>
                  <div>
                    <strong className="text-gray-900">Ongoing Support:</strong>
                    <span className="text-gray-600"> Continuous assistance beyond project completion</span>
                  </div>
                </li>
              </ul>
              <button 
                onClick={scrollToInquiryForm}
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
                Schedule Free Consultation
              </button>
            </div>
            <div className="h-64 bg-gray-200 rounded-lg overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/f592130c43aec7a1fd90e763b592fb90.jpg"
                alt="Consultancy Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
